var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"csvViewWrapper"}},[(_vm.showUploadCsv)?_c('csv-upload',{attrs:{"type":"card"},on:{"on-file-selected":_vm.handleCsvUpload}}):_vm._e(),(!_vm.showUploadCsv)?_c('csv-preview'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }